export default {
    "Language": "Idioma",
    "UserName": "Nombre de usuario",
    "Email": "Correo electrónico",
    "PassWord": "Contraseña",
    "Login": "Iniciar sesión",
    "SignUp": "Registrarse",
    "Welcome": "Bienvenido",
    "ForgotPasswrod": "¿Olvidó su contraseña?",
    "NoAccount": "¿Aún no tiene una cuenta? Regístrese",
    "ServerError": "Error del sistema",
    "ReadAgree": "He leído y acepto",
    "And": "y",
    "ScanQRCodeDownloadAPP": "Por favor, escanee el siguiente código QR para descargar la aplicación y crear una cuenta",
    "EmailEmpty": "La cuenta de correo electrónico no puede estar vacía",
    "PasswordEmpty": "La contraseña no puede estar vacía",
    "PleaseSelect": "Por favor seleccione",
    "Logout": "Cerrar sesión",
    "CreateCompany": "Crear empresa",
    "CompanyName": "Nombre de la empresa *",
    "Confirm": "Confirmar",
    "Cancel": "Cancelar",
    "CompanyNameEmpty": "El nombre de la empresa no puede estar vacío",
    "CreatedSuccessfully": "Creado con éxito",
    "CompanyDashboard": "Panel de empresa",
    "Sites": "Sitio",
    "CompanyAdmin": "Administrador de empresa",
    "PurchaseRecord": "Registro de compras",
    "MoreDetail": "Más detalles",
    "CreateSite": "Nuevo sitio",
    "Admin": "Administradores",
    "AdminAccess": "Administrar usuarios con acceso de administrador a esta empresa",
    "Licenses": "Licencias",
    "PaymentInvioces": "Ver su historial de pagos y administrar facturas de la empresa",
    "SiteName": "Nombre del sitio *",
    "SiteAddress": "Dirección *",
    "Add": "Agregar",
    "Edit": "Editar",
    "Delete": "Eliminar",
    "DeleteSiteTitle": "¿Está seguro de que desea eliminar el sitio?",
    "NoData": "Sin datos",
    "SiteNameEmpty": "El nombre del sitio no puede estar vacío",
    "SiteAddressEmpty": "La dirección del sitio no puede estar vacía",
    "UpdateSuccessfully": "Actualización exitosa",
    "DeleteSuccessfully": "Eliminado con éxito",
    "AddAdmin": "Agregar administrador",
    "AddCompanyAdmin": "Agregar administrador de empresa",
    "RegisteredAccount": "Por favor, ingrese la cuenta registrada",
    "EmailAccount": "Cuenta de correo electrónico *",
    "AdminCompanyRole": "Rol de usuario: Administrador de empresa",
    "ManagesSitesAdmins": "Gestiona todos los sitios y administradores de sitios.",
    "AccessBilling": "Realiza pagos y tiene acceso a la información de facturación.",
    "Serach": "Buscar",
    "UserInfo": "Información del usuario",
    "UserAccount": "Cuenta de usuario",
    "Nickname": "Apodo:",
    "FirstName": "Nombre *",
    "Surname": "Apellido",
    "SureDelete": "¿Está seguro de que desea eliminar?",
    "NoRecord": "Sin registros",
    "AdminName": "Nombre del administrador",
    "Account": "Cuenta",
    "Role": "Rol",
    "CreateDate": "Fecha de creación",
    "EmailEmpty": "La cuenta de correo electrónico no puede estar vacía",
    "EmailIncorrect": "La cuenta de correo electrónico no existe o es incorrecta",
    "FirstNameEmpty": "El nombre no puede estar vacío",
    "SurnameNameEmpty": "El apellido no puede estar vacío",
    "Save": "Guardar",
    "StartTime": "Hora de inicio",
    "EndTime": "Hora de finalización",
    "NoPurchaseRecord": "¡No hay registro de compras!",
    "LicenseName": "Nombre de la licencia",
    "Quantity": "Cantidad",
    "Amount": "Monto",
    "StartTimeEmptye": "La hora de inicio no puede estar vacía",
    "EndTimeEmptye": "La hora de finalización no puede estar vacía",
    "StartTimeLaterEndTime": "La hora de inicio no puede ser posterior a la hora de finalización",
    "SiteDashboard": "Panel del sitio",
    "Blocks": "Bloques",
    "Panels": "Dispositivos",
    "SiteUsers": "Usuarios del sitio",
    "EventRecords": "Registros de eventos",
    "AssessLog": "Registro de acceso",
    "SiteLicenses": "Licencias del sitio",
    "Payments": "Pagos",
    "MyProfile": "Mi perfil",
    "AddBlocks": "Agregar bloques",
    "BlocksOnSite": "Bloques en el sitio",
    "SeeAllPanels": "Ver todos los dispositivos",
    "AddPanels": "Agregar paneles",
    "AddedDecices": "Dispositivos añadidos",
    "Normal": "Normal",
    "NeedConfigration": "Requiere configuración",
    "CheckFail": "Error",
    "Offline": "Desconectado",
    "SeeAllUsers": "Ver todos los usuarios",
    "Users": "Usuarios",
    "AddUsers": "Agregar usuarios",
    "AddedUser": "Usuario añadido",
    "LicensesNormal": "Licencias activas",
    "LicensesExpired": "Licencias expiradas",
    "NotOpened": "No abierto",
    "NotAccepted": "No aceptado",
    "BuyLiences": "Comprar licencias",
    "RemainingQuantit": "Cantidad restante",
    "BuyMore": "Comprar más",
    "BlocksName": "Nombre del bloque *",
    "BlocksNumber": "Número de bloque *",
    "DeleteBlock": "Eliminar bloque",
    "CreateBlock": "Crear nuevo bloque",
    "NoBlock": "No hay bloques existentes, ¡priorice agregar bloques!",
    "PanelsQuantity": "Cantidad de paneles",
    "UsersQuantity": "Cantidad de usuarios",
    "CreateSites": "Crear nuevos sitios",
    "BlocksNameEmpty": "El nombre del bloque no puede estar vacío",
    "BlocksNumberEmpty": "El número de bloques no puede estar vacío",
    "BlockDetail": "Detalle del bloque",
    "DeletePanel": "¿Está seguro de que desea eliminar el dispositivo del campus? Después de la eliminación, desaparecerá automáticamente de la cuenta de usuario correspondiente.",
    "NoPanel": "No hay información, ¡priorice agregar dispositivos!",
    "PanelsId": "ID del panel",
    "PanelsName": "Nombre del panel",
    "PanelsStatus": "Estado del panel",
    "DeleteUser": "Después de eliminar los datos, el usuario (y el compartido) serán desvinculados y el usuario no podrá usar el servicio de entrada del parque; La operación de eliminación no se puede restaurar.",
    "NoUser": "No hay información del usuario, por favor agregue un usuario.",
    "HouseNumber": "Número de apartamento",
    "UserRole": "Rol del usuario",
    "UserStatus": "Estado del usuario",
    "ServiceStatus": "Estado de la licencia",
    "ServicesRemaining": "Duración restante",
    "BlocksDetail": "Detalle de bloques",
    "Invalid": "Inválido",
    "Ready": "En línea",
    "NeedVerification": "Requiere verificación",
    "NotResponding": "No responde",
    "Accepted": "Aceptado",
    "Refuse": "Rechazado",
    "NotBound": "No vinculado",
    "NotEnabled": "No habilitado",
    "InUse": "En uso",
    "End": "Finalizado",
    "Days": "Días",
    "CreatePanels": "Crear nuevo panel",
    "PanelsSerialNumber": "Número de serie del panel *",
    "NotFndSerial": "Si no puede encontrar el número de serie, haga clic aquí",
    "PanelsSecurityCode": "Código de seguridad del panel *",
    "PanelsSerialCode": "Si no puede encontrar el código de seguridad, haga clic aquí",
    "Or": "O",
    "RolePermission": "Control de permisos de roles",
    "SiteUser": "Usuario del sitio",
    "SiteEmployee": "Empleado del sitio",
    "SiteOther": "Otro del sitio",
    "Status": "Estado",
    "PanelsSerialNumberEmpty": "El número de serie del panel no puede estar vacío",
    "PanelsSecurityNumberEmpty": "El código de seguridad del panel no puede estar vacío",
    "PanelsNameEmpty": "El nombre del panel no puede estar vacío",
    "SiteOrBlocksEmpty": "El sitio o los bloques no pueden estar vacíos",
    "AddSuccessful": "Agregado con éxito",
    "RevalidateDevice": "Revalidar dispositivo",
    "PanelsDetail": "Detalle de los paneles",
    "AccessControl": "Control de acceso",
    "DevicesMode": "Modo de dispositivos",
    "SerialNumber": "Número de serie",
    "FirmwareVersion": "Versión de firmware",
    "Revalidate": "Revalidar",
    "UpdateFailure": "Fallo en la actualización",
    "AddSiteUser": "Agregar usuario al sitio",
    "AddingUser": "Agregando usuario, por favor espere un momento...",
    "UserEmail": "Correo electrónico del usuario",
    "ActivationMethod": "Método de activación",
    "ChooseActivationMethod": "Elija cómo activar el servicio para el usuario.",
    "AvailableActivationCodes": "Códigos de activación disponibles",
    "AddUserSuccess": "¡Usuario agregado con éxito!",
    "UserHasJoined": "El usuario se ha unido",
    "UserServiceActivated": "¡El servicio del usuario está activado!",
    "ActivationCode": "Código de activación",
    "UserConfrmation": "Confirmación del usuario",
    "ConfirmationEmail": "Se ha enviado un correo de confirmación al usuario, por favor notifíquelo para completar la operación de acuerdo con las indicaciones del correo.",
    "ScanQRCode": "O escanee el código QR con la APP para unirse",
    "ServiceActivation": "Activación del servicio",
    "Total": "Total",
    "Select": "Seleccionar",
    "Activation": "Activación",
    "UserServiceActivation": "Activación del servicio del usuario, por favor espere un momento...",
    "ConsumedActivate": "Se consumirán hojas para activar a los siguientes usuarios",
    "BindingUser": "Vinculación de usuario",
    "BindingUserWait": "Vinculando usuario, por favor espere un momento...",
    "UnbindingUser": "Desvinculación de usuario",
    "UnbindingUserDesc": "Después de la desvinculación, el usuario no podrá usar el servicio de la máquina de entrada del sitio.",
    "ActivationTypeOne": "Los usuarios compran y abren por sí mismos",
    "ActivationTypeTwo": "Asignar código de activación",
    "ActivationTypeThree": "Rellenar el código de activación",
    "Years": "años",
    "Year": "año",
    "Months": "meses",
    "Month": "mes",
    "Day": "Día",
    "UserEmailEmpty": "El correo electrónico del usuario no puede estar vacío",
    "HouseNumberEmpty": "El número de apartamento no puede estar vacío",
    "UserRoleEmpty": "El rol del usuario no puede estar vacío",
    "ActivationMethodEmpty": "El método de activación no puede estar vacío",
    "SelectAtLeastOne": "Por favor, seleccione al menos un criterio para buscar",
    "SelectAtLeastActivate": "Por favor, seleccione al menos un usuario para activar",
    "SelectLicense": "Por favor, seleccione una licencia",
    "InsufficientLicense": "Cantidad de licencias insuficiente",
    "ActivationSuccessful": "Activación exitosa",
    "BindingSuccessful": "Vinculación exitosa",
    "UnbindSuccessful": "Desvinculación exitosa",
    "UserDetail": "Detalle del usuario",
    "Devices": "Dispositivos",
    "UserSetting": "Configuración del usuario",
    "Augment": "Aumentar",
    "DeviceName": "Nombre del dispositivo",
    "DeviceId": "ID del dispositivo",
    "AccessRights": "Permisos de acceso",
    "AssessStatus": "Estado de acceso",
    "SiteDevices": "Dispositivos del sitio",
    "Preview": "Vista previa",
    "PreviewEnd": "Vista previa,",
    "Unlock": "Desbloquear",
    "UnlockEnd": "Desbloquear,",
    "Call": "Llamar",
    "CallEnd": "Llamar,",
    "NoAssessLog": "¡No se ha registrado ningún registro de acceso!",
    "OperationModule": "Módulo de operación",
    "OperationContent": "Contenido de la operación",
    "Company": "Empresa",
    "UpdateSite": "Actualizar sitio",
    "DeleteSite": "Eliminar sitio",
    "UpdateBlock": "Actualizar bloque",
    "DeleteBlock": "Eliminar bloque",
    "BindingPanels": "Vinculación de paneles",
    "UpdatePanels": "Actualizar paneles",
    "UnbindingPanels": "Desvinculación de paneles",
    "UpdateUser": "Actualizar usuario",
    "DeleteUserLog": "Eliminar usuario",
    "PurchasingLicence": "Compra de licencia",
    "UpdateCompanyAdmin": "Actualizar administrador de empresa",
    "DeleteCompanyAdmin": "Eliminar administrador de empresa",
    "UserLogin": "Inicio de sesión de usuario",
    "RocessingPayment": "Procesando datos de pago, por favor espere...",
    "PaySuccess": "Pago exitoso",
    "PayFail": "Pago fallido",
    "Person": "Apartamento",
    "BuyQuantity": "Cantidad a comprar",
    "CustomQuantity": "Cantidad personalizada",
    "PayPlatfrom": "Plataforma de pago",
    "PayAmount": "Monto de pago",
    "Pay": "Pagar",
    "ServiceLicenses": "Licencias de servicio",
    "ActivationRecords": "Registros de activación",
    "NoLicense": "¡No hay licencias disponibles, por favor compre!",
    "LicensesName": "Nombre de la licencia",
    "ActivationKey": "Código",
    "SelectLicensePurchase": "Por favor, seleccione la licencia que desea comprar",
    "PaymentFailure": "Fallo en el pago del pedido",
    "BuyNow": "Comprar ahora",
    "OrderNo": "Número de pedido",
    "OrderStatus": "Estado del pedido",
    "Date": "Fecha",
    "OrderName": "Nombre del pedido",
    "OrderTime": "Hora del pedido",
    "PayTime": "Hora de pago",
    "Pending": "Pendiente",
    "Completed": "Completado",
    "Expired": "Expirado",
    "UseAPPScanQRCode": "Utilice la aplicación QvHome para escanear el código y usar el servicio",
    "RequestParameterError": "Error en el parámetro de solicitud",
    "InvalidRequest": "Solicitud inválida",
    "RequestTimeou": "Tiempo de espera de la solicitud",
    "UserNoLogin": "Usuario no ha iniciado sesión",
    "RemoteServiceNotFound": "Servicio remoto no encontrado",
    "ErrorCallingRemoteService": "Error al llamar al servicio remoto",
    "DataNotFound": "Datos no encontrados",
    "RequestsTooFrequent": "Solicitudes demasiado frecuentes",
    "NoOperationPermission": "Sin permiso de operación",
    "DataAlreadyExists": "Los datos ya existen",
    "UserNamePassword": "El nombre de usuario y la contraseña no coinciden",
    "AccountAlreadyExists": "La cuenta ya existe",
    "VerificationCodeError": "Error en el código de verificación",
    "UnknownError": "Error desconocido",
    "NoAuthorizedCompany": "No se encontró una empresa autorizada",
    "NoAuthorizedSite": "No se encontró un sitio autorizado",
    "UserNotJoinHouse": "El usuario no se unió a la casa",
    "CloudPushNotEnabled": "El servicio de notificaciones en la nube no está habilitado",
    "DeviceBound": "Dispositivo vinculado",
    "HouseNumberAlreadyExists": "El número de apartamento ya existe",
    "HouseNumberNotExists": "El número de apartamento no existe",
    "BlockNumberNotExists": "El número de torre no existe",
    "DeviceUnbound": "Dispositivo desvinculado",
    "InventoryShortag": "Escasez de inventario",
    "PaymentOrderVerificationFailed": "Fallo en la verificación del pedido de pago",
    "PaymentFailed": "Pago fallido",
    "NoPackageFound": "No se encontró un pedido de apertura de paquete",
    "NoAvailablePackages": "No se encontraron paquetes disponibles",
    "PackageHasModified": "El paquete ha sido modificado",
    "ChangedOnce": "El paquete solo puede cambiarse una vez dentro de los 7 días",
    "OrdersNonRefundable": "Los pedidos no son reembolsables",
    "PaymentConfigurationNotFound": "No se encontró configuración de pago",
    "OrderRefundFailed": "Fallo en el reembolso del pedido",
    "PackageLessThanOneDay": "Queda menos de un día en el paquete",
    "DataSaveError": "Error al guardar los datos",
    "DataUpdateError": "Error al actualizar los datos",
    "DataDeleteError": "Error al eliminar los datos",
    "CompanyAdminExistsSite": "El administrador de la empresa ya existe en el sitio",
    "NotAllowDeleteOurself": "No se permite eliminarnos a nosotros mismos",
    "ProductNotSupportBind": "Este producto no admite vinculación",
    "DeviceSecurityCheckFail": "La verificación del código de seguridad del dispositivo ha fallado",
    "DeviceNotSupportServer": "El dispositivo no admite este servicio",
    "OemConfigNotFount": "No se encontró la configuración OEM",
    "EmailSendFail": "Fallo en el envío del correo electrónico",
    "UserAccountNotFound": "No se encontró la cuenta de usuario",
    "CompanyDataNotFond": "No se encontraron datos de la empresa",
    "DevicesDataNotFond": "No se encontraron datos del dispositivo",
    "DevicesNoPermission": "El dispositivo no tiene permisos",
    "UserNotBindingHouse": "El usuario no ha vinculado una vivienda",
    "PkgNotAvailable": "Paquete no disponible",
    "UserNotFond": "Usuario no encontrado",
    "AuthNotFound": "Autorización no encontrada",
    "IotUnlockFail": "Fallo en el desbloqueo",
    "UserMismatchOem": "El OEM del usuario no coincide",
    "AlarmCancelShareFail": "Fallo al cancelar el uso compartido de la alarma",
    "AlarmUnbindFail": "Fallo en la desvinculación de la alarma",
    "AlarmShareFail": "Fallo en la compartición de la alarma",
    "InvitationInvalid": "Invitación inválida",
    "UnallocatedLicense": "Licencia no asignada",
    "HaveBeenUsed": "Ya ha sido utilizado",
    "CompanyNameLimit": "El nombre de la empresa debe contener entre 1 y 30 caracteres",
    "SiteNotFound": "Sitio no encontrado",
    "SiteNameLimit": "El nombre del sitio debe contener entre 1 y 30 caracteres",
    "EmailFormatLimit": "El formato del correo electrónico es incorrecto",
    "FirstNameLimit": "El nombre debe tener entre 1 y 20 caracteres",
    "SurnameLimit": "El apellido debe tener entre 1 y 20 caracteres",
    "PersonalInfo": "Información personal",
    "BlockNameLimit": "El nombre del bloque debe contener entre 1 y 30 caracteres",
    "BlockNumberLimit": "El número de bloque debe contener entre 1 y 30 caracteres",
    "DeviceSerialLimit": "El número de serie del panel debe contener entre 1 y 20 caracteres",
    "DeviceSecurityCodeLimit": "El código de seguridad del panel debe contener entre 1 y 64 caracteres",
    "DeviceNameLimit": "El nombre del panel debe contener entre 1 y 30 caracteres",
    "HouseNumberLimit": "El número de apartamento debe contener entre 1 y 20 caracteres",
    "LoginExpired": "La sesión de usuario ha expirado, por favor inicie sesión nuevamente",
    "ServicesRemainingLimit": "El valor de los días restantes del servicio solo puede ser 0 o un número entero positivo de hasta 8 dígitos",
    "LastAdminNotDelete": "No se puede eliminar al último administrador",
    "CanNotUpdateOwnRoles": "No puede actualizar su rol de administrador",
    "UserUnbindingFailed": "Error al desvincular usuario",
    "AdminAccountLimit": "Las cuentas de administrador deben contener entre 1 y 100 caracteres",
    "UserNameLimit": "El nombre de usuario debe contener entre 1 y 30 caracteres",
    "OrderNoLimit": "El número de pedido debe contener entre 1 y 64 caracteres",
    "licensesNumLimit": "Solo se pueden ingresar números enteros positivos entre 1 y 999",
    "BlockNumberNotZero": "El número de bloque no puede ser 0",
    "CompanyOverLimit": "Se ha superado el límite de empresas creadas",
    "SiteOverLimit": "Se ha superado el límite de sitios creados",
    "ApartmentOverLimit": "Se ha superado el límite de apartamentos creados",
    "Notice": "Avisos",
    "PanelLog": "Registro de panel",
    "OperationLog": "Registro de operaciones",
    "Panel": "Panel",
    "CallHasBeenAnswered": "La llamada ha sido respondida",
    "CallNotAnswered": "Llamada no respondida",
    "Time": "Hora",
    "Default": "Predeterminado",
    "QRCodeUnlock": "Desbloqueo con código QR",
    "PasswordUnlock": "Contraseña de desbloqueo",
    "IndoorMachineUnlock": "Desbloqueo de máquina interior",
    "AppUnlock": "Desbloqueo desde la aplicación",
    "RfCard": "Tarjeta RF",
    "ExitButton": "Desbloqueo con botón de salida",
    "DtmfUnlock": "Desbloqueo DTMF",
    "GoogleUnlock": "Desbloqueo con Google",
    "AlexaUnlock": "Desbloqueo con Alexa",
    "FaceUnlock": "Desbloqueo facial",
    "Success": "Éxito",
    "Failed": "Fallido",
    "Loading": "Cargando",
    "ApartmentNumber": "Número de apartamento",
    "Image": "Imagen",
    "CallLog": "Registro de llamadas",
    "AccessLog": "Registro de accesos",
    "Export": "Exportar",
    "UnlockType": "Tipo de desbloqueo",
    "NoExportData": "¡No hay datos para exportar!",
    "ExportSuccess": "Exportación exitosa",
    "Return": "Regresar",
    "APPNotice": "Notificación de la aplicación",
    "DeviceNotice": "Notificación del dispositivo",
    "Refresh": "Actualizar",
    "AddNotice": "Añadir aviso",
    "Withdraw": "Retirar",
    "Release": "Publicar",
    "More": "Más",
    "Broadcast": "Transmisión",
    "ChooseDevice": "Seleccionar dispositivo",
    "ReceptionDevice": "Dispositivo de recepción：",
    "SelectedDeviceNumber": "Número de dispositivos seleccionados：",
    "Title": "Título：",
    "DigitsLimit": "La longitud del título debe ser de 1 a 50 caracteres",
    "TitlePicture": "Imagen del título：",
    "PictureRatio": "Nota: Recomendamos subir una imagen con una relación de aspecto de 9:16",
    "TimeRange": "Rango de tiempo：",
    "CreateNotice": "Crear aviso",
    "Update": "Actualizar",
    "Modify": "Modificar",
    "Content": "Contenido",
    "ReleaseStatus": "Estado de publicación",
    "Released": "Publicado",
    "TitleTable": "Título",
    "Draft": "Borrador",
    "TitlePictureEmpty": "Por favor, añade la imagen del título",
    "DeleteFailed": "Eliminación fallida",
    "ImageUploadFailed": "Error al subir la imagen",
    "PleaseSelectDevice": "Por favor, selecciona un dispositivo",
    "MaximumDevicesSelected": "Se pueden seleccionar un máximo de 10 dispositivos",
    "SuccessfulWithdraw": "Retiro exitoso",
    "SuccessfulRelease": "Publicación exitosa",
    "RemoveDeviceNotice": "Eliminar aviso del dispositivo",
    "WithdrawDeviceNotice": "Retirar aviso del dispositivo",
    "ReleaseDeviceNotice": "Publicar aviso del dispositivo",
    "UpdateNotice": "Actualizar aviso",
    "UploadImagejpg": "¡Por favor, sube una imagen con extensión .jpg!",
    "ConfirmPassword": "Confirmar contraseña",
    "Prompt": "Mensaje",
    "AutoJumpLogin": "Se redirigirá automáticamente a la página de inicio de sesión en 0 segundos. Haz clic en Confirmar para ir inmediatamente.",
    "RegisteredSuccess": "Registro exitoso",
    "PasswordChangedSuccess": "Contraseña cambiada con éxito",
    "SendVerificationCode": "Enviar código de verificación",
    "ResendSeconds": "Reenviar en 0 segundos",
    "VerificationCode": "Código de verificación",
    "PasswordFormatLimit": "La contraseña debe tener entre 8 y 16 caracteres, contener letras mayúsculas y minúsculas, números y caracteres especiales.",
    "ChangePassword": "Cambiar contraseña",
    "NextStep": "Siguiente",
    "EnterVerificationCode": "Por favor, introduce el código de verificación",
    "EnterCorrectEmailFormat": "Por favor, introduce un formato de correo electrónico correcto",
    "PasswordLess": "La contraseña no debe tener menos de 8 caracteres",
    "PasswordLarger": "La contraseña no debe tener más de 16 caracteres",
    "PasswordNotRules": "La contraseña no cumple con las reglas",
    "EntePasswordAgain": "Por favor, introduce la contraseña nuevamente",
    "PasswordNotMatch": "La contraseña y la confirmación no coinciden",
    "VerificationCodeSentSuccess": "El código de verificación se envió correctamente",
    "UrlExpired": "La URL ha expirado",
    "EmailAccountExists": "La cuenta de correo electrónico ya existe",
    "VerificationCodeIncorrect": "El código de verificación es incorrecto",
    "VerificationCodeInvalid": "El código de verificación no es válido",
    "TermsCondition": "Términos y condiciones",
    "PrivacyPolicy": "Política de privacidad",
    "CheckReadAgree": "Por favor, marca que has leído y aceptas los términos y condiciones y la política de privacidad",
    "DisplayName": "Nombre para mostrar",
    "AccountSettings": "Configuración de cuenta",
    "Remark": "Observación",
    "Server": "Servidor",
    "Port": "Puerto",
    "TCPOrUDP": "TCP/UDP",
    "DTMFSetting": "Configuración DTMF",
    "Lock1": "Cerradura 1",
    "Lock2": "Cerradura 2",
    "Talk": "Hablar",
    "DisplayNameEmpty": "El nombre para mostrar debe contener entre 1 y 64 caracteres",
    "RemarkEmpty": "La observación debe contener entre 1 y 64 caracteres",
    "ServerEmpty": "El servidor debe contener entre 1 y 64 caracteres",
    "PortEmpty": "El puerto debe contener entre 1 y 20 caracteres",
    "TCPOrUDPEmpty": "TCP/UDP no puede estar vacío",
    "AccountEmpty": "La cuenta debe contener entre 1 y 64 caracteres",
    "Lock1Empty": "La cerradura 1 debe contener entre 1 y 20 caracteres",
    "Lock2Empty": "La cerradura 2 debe contener entre 1 y 20 caracteres",
    "TalkEmpty": "Hablar debe contener entre 1 y 20 caracteres",
    "NoSip": "Sin información, por favor, agrega un nuevo servidor SIP primero.",
    "PasswordLimit": "La contraseña debe contener entre 1 y 64 caracteres",
    "NoGuard": "Sin información, por favor, agrega un nuevo guardia primero.",
    "SipSettings": "Configuración SIP",
    "GuardSettings": "Configuración de guardia",
    "ConfirmDelSip": "¿Confirmar eliminación de la configuración SIP?",
    "GuardNameLimit": "El nombre del guardia debe contener entre 1 y 20 caracteres",
    "AddressEmpty": "La dirección no puede estar vacía",
    "GuardName": "Nombre del guardia",
    "CreateGuard": "Crear nuevo guardia",
    "EditGuard": "Editar guardia",
    "Address": "Dirección",
    "ConfirmDelGuard": "¿Confirmar eliminación del guardia?",
    "AddSipServer": "Añadir nuevo servidor SIP",
    "ConfirmUnbindPanel": "¿Confirmar desvinculación del panel?",
    "PleaseSelectPanels": "Por favor, selecciona paneles",
    "ServerConfigEmpty": "La configuración del servidor no puede estar vacía",
    "Mode": "Modo",
    "SeverMode": "Modo de servidor",
    "P2PMode": "Modo P2P",
    "ServerConfig": "Configuración del servidor",
    "TargetSip": "SIP objetivo",
    "P2PConfig": "Configuración P2P",
    "CreateDeviceConfig": "Crear configuración del dispositivo",
    "UpdateDeviceConfig": "Actualizar configuración del dispositivo",
    "DeleteDeviceConfig": "Eliminar configuración del dispositivo",
    "CreateUserHouseConfig": "Crear configuración de usuarios del sitio",
    "UpdateUserHouseConfig": "Actualizar configuración de usuarios del sitio",
    "DeleteUserHouseConfig": "Eliminar configuración de usuarios del sitio",
    "CreateDeviceGuardConfig": "Crear configuración de guardia del dispositivo",
    "UpdateDeviceGuardConfig": "Actualizar configuración de guardia del dispositivo",
    "DeleteDeviceGuardConfig": "Eliminar configuración de guardia del dispositivo",
    "CreateDeviceNotice": "Crear aviso de dispositivo",
    "UpdateDeviceNotice": "Actualizar aviso de dispositivo",
    "DeleteDeviceNotice": "Eliminar aviso de dispositivo",
    "DeviceNoticeRelease": "Publicar aviso de dispositivo",
    "DeviceNoticeWithdraw": "Retirar aviso de dispositivo",
    "EnterTitle": "Por favor, ingresa el título",
    "Unused": "No usar",
    "ServerName": "Nombre del servidor",
    "DeviceDelete": "Eliminar dispositivo",
    "PrivateMessage": "Mensaje privado",
    "Profile": "Perfil",
    "EnableProfile": "Habilitar perfil",
    "DisableProfile": "Deshabilitar perfil",
    "WhetherEnableProfile": "Si el perfil está habilitado",
    "WhetherDisableProfile": "Si el perfil está deshabilitado",
    "PleaseSelectUser": "Por favor, selecciona un usuario",
    "MaximumUserSelected": "Se pueden seleccionar un máximo de 10 usuarios",
    "SelectedUserNumber": "Número de usuarios seleccionados：",
    "RemoveAppNotice": "Eliminar aviso de la app",
    "WithdrawAppNotice": "Retirar aviso de la app",
    "ReleaseAppNotice": "Publicar aviso de la app",
    "TamperLog": "Registro de manipulación",
    "ReleaseType": "Tipo de publicación",
    "ReadNumber": "Número de lecturas",
    "MaximumCharacterLimit": "El contenido solo puede contener un máximo de 1 carácter",
    "MaximumNoticeReachLimit": "Se ha alcanzado el número máximo de anuncios",
    "UploadedImageLimit": "¡El tamaño de la imagen subida no puede exceder los 2 MB!",
    "ContentCannotEmpty": "¡El contenido no puede estar vacío!",
    "EndTimeGreateCurrentTime": "¡La hora de finalización debe ser mayor que la hora actual!",
    "AccountNotExist": "La cuenta no existe",
    "PasswordError": "La contraseña es incorrecta",
    "PictureRatioApp": "Nota：Recomendamos subir una imagen con una proporción de 16:9",
    "Name": "Nombre",
    "NameCannotEmpty": "Los nombres deben tener entre 1 y 64 caracteres",
    "CardNumber": "Número de tarjeta completo",
    "CardNumberEmpty": "El número de tarjeta completo no puede estar vacío",
    "UnlockOption": "Opción de desbloqueo",
    "UnlockOptionEmpty": "La opción de desbloqueo no puede estar vacía",
    "Limited": "Limitado",
    "LimitedEmpty": "El límite no puede estar vacío",
    "CardSettings": "Configuración de tarjeta",
    "LimitedUse": "Uso limitado",
    "ValidityTime": "Tiempo de validez",
    "PanelSync": "Sincronización del dispositivo",
    "AddCardNumber": "Añadir número de tarjeta",
    "NumbeOfUses": "Número de usos",
    "Unlinmited": "Ilimitado",
    "Forever": "Para siempre",
    "EditCardNumber": "Editar número de tarjeta",
    "ConfirmDeleteCard": "¿Confirmar eliminación de la configuración de la tarjeta?",
    "NotApplied": "No aplicado",
    "ApplicationComplete": "Aplicación completada",
    "DataValidationFailed": "Error en la validación de datos",
    "TypesNotSupported": "Tipos no soportados",
    "DeviceLimitedInput": "Límite de entrada del dispositivo",
    "CCTVSettings": "Configuración de CCTV",
    "IPRTSPUrl": "IP/RTSP Url",
    "Stream": "Transmisión",
    "DeletingCCTV": "¿Confirmar eliminación de la configuración de CCTV?",
    "MainStream": "Transmisión principal",
    "SubStream": "Subtransmisión",
    "AddCamera": "Añadir cámara",
    "EditCamera": "Editar cámara",
    "IPRTSPUrlEmpty": "La IP/RTSP Url no puede estar vacía",
    "UsernameEmpty": "El nombre de usuario no puede estar vacío",
    "StreamEmpty": "La transmisión no puede estar vacía",
    "DeviceVersion": "Versión del dispositivo",
    "CardNumberExists": "El número de tarjeta ya existe",
    "AddCard": "Añadir tarjeta",
    "FacilityCodeCardNumber": "Código de instalación y número de tarjeta",
    "PleasePlacePard": "Por favor, coloca una tarjeta en el lector",
    "ReaderNotDetected": "¡No se detectó el lector, por favor revisa la instalación del controlador o la conexión del cable!",
    "DownloadDriver": "Descargar controlador",
    "TestDriver": "Probar controlador",
    "ChooseDriverDownload": "Por favor, elige el controlador correspondiente para descargar según el sistema de tu PC",
    "RestartTest": "Reiniciar para probar",
    "FacilityCode": "Código de instalación",
    "FullCardNumLimit": "El número de tarjeta ingresado no es válido. Por favor, ingrésalo de nuevo",
    "FacilityCodeCardNumberEmpty": "El código de instalación y el número de tarjeta no pueden estar vacíos",
    "FacilityCodeEmpty": "El código de instalación debe ser numérico y no puede ser mayor que 255",
    "FacilityCardNumberEmpty": "El número de tarjeta debe ser un número y no puede ser mayor que 65535",
    "ManualInput": "Entrada manual",
    "Reader": "Lector",
    "SiteList": "Lista de sitios",
    "ManageSelectedSite": "Gestionar sitio seleccionado",
    "ManageSelectEmpty": "Por favor, selecciona el sitio a gestionar",
    "AdminAccountExists": "La cuenta de administrador ya existe",
    "CompanyNameOnly": "Nombre de la empresa",
    "DeleteCompanyLimit": "Por favor, elimina todos los sitios de la empresa antes de eliminarla",
    "CompanyList": "Lista de empresas",
    "Rename": "Renombrar",
    "InputNewCompanyName": "Por favor, introduce un nuevo nombre para la empresa",
    "SureDeleteCompany": "¿Estás seguro de que deseas eliminar la empresa?",
    "SelectPayPlatform": "Por favor, selecciona la plataforma de pago",
    "LimitReached": "Se ha alcanzado el límite",
    "LimitPassword": "La longitud máxima de la contraseña no puede superar los 64 caracteres",
    "LimitUserName": "La longitud máxima de un nombre de usuario no puede superar los 64 caracteres",
    "LimitUnlockNum": "El número máximo de restricciones no puede superar los 100",
    "LimitHouseNumber": "El número de apartamento solo admite letras mayúsculas y minúsculas o números y debe ser mayor que 0 si son números puros",
    "LimitBlockNumber": "El número de bloque solo puede ser numérico y debe ser mayor que 0",
    "CardNumberWrong": "El número de tarjeta es incorrecto",
    "UsersReachLimit": "Se ha alcanzado el límite de usuarios añadidos",
    "DeviceReachLimit": "Se ha alcanzado el límite de dispositivos añadidos",
    "UserMessages": "Mensajes de usuario",
    "MessagesPending": "Pendiente",
    "BeingProcessed": "En proceso",
    "MessagesEnd": "Finalizado",
    "EmailOrPhone": "Correo/Teléfono",
    "ReplyMessage": "Responder al mensaje",
    "Picture": "Imagen",
    "Description": "Descripción",
    "Reply": "Responder",
    "Denied": "Denegado",
    "Finished": "Terminado",
    "Processing": "Procesando",
    "ReplyContents": "Contenido de la respuesta",
    "EnterReplyContents": "Por favor, ingrese el contenido de la respuesta",
    "Submit": "Enviar",
    "Back": "Volver",
    "Process": "Procesar",
    "Administrator": "Administrador",
    "FileExceed": "Se pueden subir un máximo de 2 imágenes",
    "ReplyEmpty": "¡La respuesta no puede estar vacía!",
    "UserMessageStatusUpdate": "¡Actualización del estado del mensaje del usuario exitosa!",
    "UserMessageReply": "¡Respuesta al mensaje del usuario exitosa!",
    "PackUp": "Ocultar",
    "DisablePreview": "Deshabilitar vista previa",
    "DisableUnlock": "Deshabilitar desbloqueo",
    "DisableCall": "Deshabilitar llamada",
    "SubmitLimit": "Se pueden enviar un máximo de 5 mensajes sin respuesta",
    "DeviceNotOnline": "El dispositivo no está en línea",
    "UploadImagejpgOrPng": "¡Por favor, suba imágenes con extensión .jpg o .png!",
    "ProblemType": "Tipo de problema",
    "Question": "Pregunta",
    "BUG": "ERROR",
    "Suggestion": "Sugerencia",
    "APPOrPhone": "App/Teléfono",
    "Others": "Otros",
    "Country": "País",
    "Permissions": "Permisos",
    "PrivateIPC": "IPC Privado",
    "PublicIPC": "IPC Público",
    "PasswordErrorTime": "La contraseña es incorrecta, la cuenta se bloqueará después de 1 intento(s)",
    "AccountLockedTime": "Cuenta bloqueada, inténtelo de nuevo en 1 segundo(s)",
    "UserPasswordUnlock": "Desbloquear contraseña",
    "AddPasswordUnlock": "Añadir desbloqueo de contraseña",
    "EditPasswordUnlock": "Editar desbloqueo de contraseña",
    "ConfirmDeletePassword": "¿Confirma la eliminación de la configuración de desbloqueo de contraseña?",
    "CarPlateSettings": "Configuración de matrícula",
    "AddCarPlate": "Añadir número de matrícula",
    "RemakeName": "Volver a crear nombre",
    "CarPlateNumber": "Número de matrícula",
    "EditCarPlate": "Editar número de matrícula",
    "ConfirmDeleteCarPlate": "¿Confirmar eliminación de la configuración de la matrícula?",
    "CardNameExists": "El nombre de la tarjeta ya existe",
    "AutomaticOpeningTimes": "Horarios de apertura automática",
    "LockName": "Nombre del bloqueo",
    "ModeSelection": "Selección de modo",
    "MomentaryUnlock": "Desbloqueo momentáneo",
    "HoldOpen": "Mantener abierto",
    "Sunday": "Domingo",
    "Monday": "Lunes",
    "Tuesday": "Martes",
    "Wednesday": "Miércoles",
    "Thursday": "Jueves",
    "Friday": "Viernes",
    "Saturday": "Sábado",
    "SundayShort": "Domingo",
    "MondayShort": "Lunes",
    "TuesdayShort": "Martes",
    "WednesdayShort": "Miércoles",
    "ThursdayShort": "Jueves",
    "FridayShort": "Viernes",
    "SaturdayShort": "Sábado",
    "EmailNotificationsFrequent": "Las notificaciones por correo electrónico son demasiado frecuentes",
    "Plan1": "Plan 1",
    "DaySelection": "Selección de día",
    "All": "Todos",
    "Apply": "Aplicar",
    "SelectionTime": "Seleccionar hora",
    "DeviceNotSupportConfig": "Esta configuración no es compatible con el dispositivo",
    "PleaseDaySelection": "Seleccione una fecha",
    "PleaseSelectPlan": "Seleccione el plan de apertura de cerraduras",
    "ApplicationSuccessful": "Aplicación correcta",
    "LiftRelaySettings": "Configuración del relé del ascensor",
    "LiftEnable": "Habilitar ascensor",
    "RelayQuantity": "Cantidad de relés",
    "Relay": "Relé",
    "RelayLimit": "Los números de retransmisión solo admiten números negativos, letras o dígitos",
    "AccountNickname": "Apodo de la cuenta",
    "RelayQuantityEmpty": "La cantidad de relés no puede estar vacía",
    "RelayConfigurationEmpty": "La configuración del relé no puede estar vacía",
    "RelayLengthLimit": "La longitud del relé debe estar entre 1 y 20 caracteres",
    "4GStrength": "Intensidad 4G",
    "4GProvider": "Proveedor 4G",
    "FloorNumber": "Número de piso",
    "FloorNumberLengthLimit": "El número de piso solo puede contener letras o números y debe tener entre 1 y 20 caracteres",
    "PleaseConfigLiftRelay": "Configure primero la configuración del relé del ascensor",
    "PleaseSelectFloorNumber": "Seleccione el número de piso",
    "APPUnlockPermission": "Roles de control de acceso en la aplicación",
    "CarPlateUnlock": "Desbloqueo con matrícula",
    "QRCodeUnlock": "Desbloqueo con código QR",
    "UnlockPasswordEmpty": "La contraseña de desbloqueo no puede estar vacía",
    "LockTemplate": "Bloquear",
    "QRCode": "Código QR",
    "ShareQRCode": "Comparte el código QR de desbloqueo con tus amigos, escanéalo delante del interfono exterior para desbloquear la puerta",
    "DownloadTemplate": "Descargar",
    "AddQRCodeUnlock": "Añadir desbloqueo con código QR",
    "EditQRCodeUnlock": "Editar desbloqueo con código QR",
    "ConfirmDeleteQRCode": "¿Confirmas que deseas eliminar la configuración de desbloqueo con código QR?",
    "AddFaceUnlock": "Añadir desbloqueo facial",
    "FaceRecord": "Grabación facial",
    "UnableAccessCamera": "No se puede acceder a la cámara. Comprueba si la cámara está correctamente conectada y si se permite el acceso a la misma",
    "FaceModelFailedLoad": "No se ha podido cargar el modelo de detección facial",
    "CameraSuccessActivated": "La cámara se ha activado correctamente",
    "PleaseTurnOnCamera": "Encienda primero la cámara",
    "FaceDetectionModelNotLoaded": "El modelo de detección facial aún no se ha cargado por completo",
    "PhotoInspectionFailed": "Error en la inspección de la foto",
    "PleaseTakePhotoOrUploadPicture": "Haga una foto o suba una imagen de su rostro",
    "FaceDetectionFailed": "Error en la detección facial",
    "ValidatingImage": "Validación de imagen",
    "ImageValiditedSuccessfully": "¡Imagen validada correctamente!",
    "ImageValiditedFailed": "¡Error en la validación de la imagen!",
    "Retry": "Reintentar",
    "UnlockQRCode": "Desbloquear código QR",
    "ClickToDisplay": "Haga clic para mostrar",
    "ClickToCapture": "Haga clic para capturar",
    "ConfirmDeleteFaceUnlockSetting": "¿Confirma que desea eliminar la configuración de desbloqueo facial?",
    "UnlockFace": "Desbloquear cara",
    "ShareManagement": "Gestión de uso compartido",
    "ShareAccount": "Cuenta compartida",
    "Alias": "Compartido con",
    "WantToShare": "Introduzca la cuenta con la que desea compartir",
    "ScanQRCodeFriend": "Deje que sus amigos escaneen el código QR que aparece a continuación con la aplicación AES Opyn y accedan al dispositivo compartido",
    "Link": "Enlace",
    "FriendsFamily": "¿Tus amigos y familiares no están contigo? Prueba con",
    "ShareLink": "Compartir enlace",
    "AccountNnumberEmpty": "¡El número de cuenta no puede estar vacío!",
    "ShareSuccess": "Compartir con éxito",
    "PendingAcceptance": "Esperando",
    "Ignored": "Ignorado",
    "Rejected": "Rechazado",
    "SharerHasDeleted": "El usuario que ha compartido ha eliminado el contenido",
    "UserHasShared": "Este usuario ha sido compartido",
    "CannotSharedOneself": "No se puede compartir con uno mismo",
    "SendSharingMessage": "Enviar un mensaje para compartir",
    "ConfirmDeleteShare": "¿Confirmar eliminar el contenido compartido?",
    "NameExists": "El nombre ya existe. ",
    "CardNumberExceedDigits": "¡La longitud del número de tarjeta no puede superar los 10 dígitos!",
    "ReInvite": "Volver a invitar",
    "InvitationDetail": "Detalles de la invitación",
    "Resend": "Reenviar",
    "EmailSendSuccess": "El correo electrónico se ha enviado correctamente",
    "DeleteSiteUser": "¿Está seguro de que desea eliminar el usuario actual? ¡La licencia asociada también se eliminará!",
    "BatchImportOrExport": "Importación por lotes",
    "ImportField": "Importar",
    "ExportField": "Exportar",
    "ExportTip": "¿Está seguro de que desea exportar el Excel predeterminado al equipo local para su configuración?",
    "ImportedSuccess": "¡Todos los datos se han importado correctamente!",
    "ImportedNotAllSuccessful": "98 unidades correctas, 2 unidades fallidas. Haga clic en el botón \"Descargar\" de la parte inferior para comprobar y volver a importar",
    "DataSync": "Sincronización de datos",
    "UploadFilexls": "El archivo que se va a cargar debe tener la extensión .xlsx o .xls",
    "Reverse": "Invertir",
    "PleaseSelectSiteOrBlocks": "Seleccione un sitio o bloque",
    "OriginalPrice": "Precio original",
    "ExportImportFieldUser": "Esta función está diseñada para facilitar a los instaladores la importación de datos de destino. Utilice la función \"Exportar\" antes de cada operación de importación por lotes y revise detenidamente las notas de uso que se incluyen en la tabla",
    "ExportImportFieldCard": "Esta función está diseñada para facilitar a los instaladores la importación de datos de destino. Utilice la función \"Exportar\" antes de cada operación de importación por lotes y revise detenidamente las notas de uso que se incluyen en la tabla",
    "PasswordUnlockLimit": "La contraseña debe tener entre 4 y 12 dígitos",
    "DeviceDataDuplication": "Duplicación de datos del dispositivo",
    "CurrentNumberApartmentMax": "El número actual de apartamentos compartidos ha alcanzado su máximo. Elimine alguno y vuelva a intentarlo",
    "ApartmentNumberExist": "Este código de apartamento ya está en uso. Elija otro código",
    "AddOnePanelUse": "Añada al menos un panel en el sitio o bloque antes de utilizar esta función",
    "GuardMaximumLimit": "El número de guardias ha alcanzado el límite máximo",
    "Importing": "Importando...",
    "ParkingCardNumber": "Número de tarjeta de aparcamiento",
    "ParkingCardNumberLimit": "¡El número de tarjeta de aparcamiento debe ser un número decimal comprendido entre 1 y 16 777 215!",
    "ParkingCardNumberExists": "El número de tarjeta de aparcamiento ya existe.",
    "GeneralSettings": "Configuración general",
    "RFID": "RFID",
    "CarPlate": "Matrícula",
    "WiegandInput": "Entrada Wiegand",
    "PlateNumberExists": "El número de matrícula ya existe",
    "PlateNumberEmpty": "El número de matrícula debe tener entre 1 y 64 caracteres",
    "LimitUnlockNumLimit": "El recuento límite debe ser un número, y debe ser como mínimo 1 y como máximo 999",
    "ChangeAssessStatusDesc": "Tenga en cuenta que las credenciales de desbloqueo deben marcarse manualmente de nuevo para este panel.",
    "ImportPrompt": "Importar",
    "ExportPrompt": "Exportar",
    "CreateNewDevice": "Crear nuevo dispositivo",
    "DeviceType": "Tipo de dispositivo",
    "AccessControlTerminal": "Teclado",
    "PleaseSelectDeviceType": "Por favor seleccione el tipo de dispositivo",
    "DeviceSerialNumberEmpty": "El número de serie del dispositivo no puede estar vacío",
    "DeviceSecurityNumberEmpty": "El código de seguridad del dispositivo no puede estar vacío",
    "DeviceNameEmpty": "El nombre del dispositivo no puede estar vacío",
    "DeviceNameLimitNew": "El nombre del dispositivo debe contener entre 1 y 30 caracteres",
    "DeviceSerialLimitNew": "El número de serie del panel debe contener entre 1 y 20 caracteres",
    "DeviceSecurityCodeLimitNew": "El código de seguridad del panel debe contener entre 1 y 64 caracteres",
    "DeviceSerialNumber": "Número de serie del dispositivo *",
    "DeviceSecurityCode": "Código de seguridad del dispositivo *",
    "Error": "Error",
    "DeviceTypeError": "El dispositivo añadido no coincide con el modelo seleccionado. ¡Por favor utilice el dispositivo correcto para añadirlo!",
    "CreateNewACT": "Crear nuevo Teclado",
    "BluetoothVersion": "Versión de Bluetooth",
    "MCUVersion": "Versión MCU",
    "BluetoothMac": "Dirección MAC BLE",
    "IPAddress": "Dirección IP",
    "DeviceStatus": "Estado del dispositivo",
    "DeviceLog": "Registro del dispositivo",
    "MasterCode": "Código maestro",
    "RelayActivationTime": "Tiempo de activación del relé",
    "ButtonBeep": "Pitido del botón",
    "HoldOpen": "Mantener abierto",
    "ExitButtonUnlockTime": "Tiempo de desbloqueo del botón de salida",
    "ToneVolume": "Volumen del tono",
    "TamperAlarm": "Alarma antisabotaje",
    "ContinuousInputErrorProtection": "Protección contra errores de entrada continuos",
    "TimeZone": "Zona horaria",
    "OFF": "APAGADO",
    "ON": "ENCENDIDO",
    "MaterCodeLimit": "La longitud de la contraseña debe ser de 6 a 12 dígitos.",
    "RelayActivationTimeLimit": "El tiempo de activación del relé debe ser un número entre 1 y 99 y no puede comenzar con 0.",
    "UnlockBluetooth": "Desbloqueo por Bluetooth",
    "UnlockFingerPrint": "Desbloqueo por huella dactilar",
    "WiegandUnlock": "Desbloqueo Wiegand",
    "DeviceDetail": "Detalles del dispositivo",
    "BindingDevice": "Vincular dispositivo",
    "UpdateDevice": "Actualizar dispositivo",
    "UnbindingDevice": "Desvincular dispositivo",
    "ConfirmUnbindDevice": "¿Confirmar la desvinculación del dispositivo?",
}